import React from 'react';
import { Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { TextField, InputLabel, MenuItem, Select, FormHelperText, FormControl, makeStyles, Button } from '@material-ui/core';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';

const useStyles = makeStyles(theme => ({
  inputRoot: {
    fontSize: 16
  },
  labelRoot: {
    fontSize: 16
  },
  labelFocused: {},
  button: {
    fontSize: 12,
    color: 'white !important',
    fontWeight: 'bold',
    borderRadius: '5px !important',
    padding: '5px !important',
    backgroundColor: `${theme.palette.primary.main} !important`
  },
  helperText: {
    fontSize: 12
  }
}));

function TextInput(props) {

  const { name, id, onChange, label, errors, inputProps, inputRef, defaultValue, colSize, disabled ,...textFieldProps} = props;

  const classes = useStyles();

  return (
    <Col sm={colSize || 6}>
      <FormControl fullWidth>
        <TextField
          name={name}
          id={id}
          defaultValue={defaultValue}
          onChange={onChange}
          label={label}
          error={!!errors}
          helperText={errors && errors.message}
          variant="standard"
          disabled={disabled}
          inputRef={inputRef}
          InputProps={{ ...inputProps, classes: { root: classes.inputRoot } }}
          InputLabelProps={{
            classes: {
              root: classes.labelRoot,
              focused: classes.labelFocused
            }
          }}
          {...textFieldProps}
          FormHelperTextProps={{ classes: { root: classes.helperText } }}
        />
      </FormControl>
    </Col>
  );
}

function TextInputValue(props) {

  const { name, id, onChange, label, errors, inputProps, inputRef, defaultValue, colSize, disabled } = props;

  const classes = useStyles();

  return (
    <Col sm={colSize || 6}>
      <FormControl fullWidth>
        <TextField
          name={name}
          id={id}
          value={defaultValue}
          onChange={onChange}
          label={label}
          error={!!errors}
          helperText={errors && errors.message}
          variant="standard"
          disabled={disabled}
          inputRef={inputRef}
          InputProps={{ ...inputProps, classes: { root: classes.inputRoot } }}
          InputLabelProps={{
            classes: {
              root: classes.labelRoot,
              focused: classes.labelFocused
            }
          }}
          FormHelperTextProps={{ classes: { root: classes.helperText } }}
        />
      </FormControl>
    </Col>
  );
}


export const NumberInputValue = (props) => {

  const { name, id, onChange, label, errors, inputProps, inputRef, defaultValue, colSize, disabled } = props;

  const classes = useStyles();

  return (
    <Col sm={colSize}>
      <FormControl fullWidth>
        <TextField
          type="number"
          name={name}
          id={id}
          value={defaultValue}
          onChange={onChange}
          label={label}
          error={!!errors}
          helperText={errors && errors.message}
          variant="standard"
          disabled={disabled}
          inputRef={inputRef}
          InputProps={{ ...inputProps, classes: { root: classes.inputRoot } }}
          InputLabelProps={{
            classes: {
              root: classes.labelRoot,
              focused: classes.labelFocused
            }
          }}
          FormHelperTextProps={{ classes: { root: classes.helperText } }}
        />
      </FormControl>
    </Col>
  );
}

function DropdownInput(props) {

  const { name, id, onChange, label, errors, inputRef, defaultValue, colSize, disabled, menuItems } = props;

  const selectMenuItems = menuItems.map((v, i) => <MenuItem key={i} value={v.value}>{v.text || v.label}</MenuItem>)

  return (
    <Col sm={colSize || 6}>
      <FormControl fullWidth error={!!errors}>
        <InputLabel htmlFor={id}>{label}</InputLabel>
        <Select
          name={name}
          id={id}
          value={defaultValue}
          onChange={onChange}
          error={!!errors}
          variant="standard"
          disabled={disabled}
          inputRef={inputRef}
        >
          {selectMenuItems}
        </Select>
        {errors && <FormHelperText id={`${id}-helper-text`}
                          aria-describedby={`${id}-helper-text`}>{errors.message}</FormHelperText>}
      </FormControl>
    </Col>
  );
}

DropdownInput.propTypes = {
  name: PropTypes.string,
  id: PropTypes.string,
  onChange: PropTypes.func,
  label: PropTypes.string.isRequired,
  errors: PropTypes.any,
  inputProps: PropTypes.any,
  defaultValue: PropTypes.any,
  colSize: PropTypes.number,
  disabled: PropTypes.bool,
  inputRefs: PropTypes.any,
  menuItems: PropTypes.array.isRequired
}

function SubmitButton(props) {

  const { buttonText } = props;

  const classes = useStyles();

  return (
    <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
      <Button className={classes.button} variant="contained" type="submit" color="primary">{buttonText}</Button>
    </div>
  )
}

function KeyboardDatePickerInput(props) {

  const { label, id, name, value, onChange, colSize, disabled, inputRef, errors, ...keyboardDatePickerProps } = props;

  return (
    <Col sm={colSize || 6}>
      <FormControl fullWidth>
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <KeyboardDatePicker
          name={name}
          id={id}
          value={value}
          onChange={onChange}
          format="MM/dd/yyyy"
          autoOk
          inputVariant="standard"
          disabled={disabled}
          inputRef={inputRef}
          error={!!props.errors}
          helperText={props.errors && props.errors.message}
          label={label}
          InputLabelProps={{
            shrink: value ? true : undefined,
          }}
          KeyboardButtonProps={{
            'aria-label': `enter ${label}`,
          }}
          {...keyboardDatePickerProps}
        />
      </MuiPickersUtilsProvider>
    </FormControl>
    </Col>
  )
}

KeyboardDatePickerInput.propTypes = {
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  inputRef: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  value: PropTypes.string,
  errors: PropTypes.object,
}

export { TextInput, TextInputValue, SubmitButton, DropdownInput, KeyboardDatePickerInput }


// WEBPACK FOOTER //
// ./src/components/Inputs/FormInputs.js